export const notificationsData = [
  // City Notifications - Vilnius
  {
    id: 1,
    title: "Water Supply Interruption",
    description: "Planned water outage in Antakalnis district tomorrow from 9AM to 2PM due to pipe repairs.",
    time: "10:15",
    date: "2025-05-08",
    category: "utility",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius City Municipality",
    threadId: "vil-water-05-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 2,
    title: "Water Service Restored",
    description: "Water supply in Antakalnis has been restored ahead of schedule. Thank you for your patience.",
    time: "13:30",
    date: "2025-05-09",
    category: "utility",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius City Municipality",
    threadId: "vil-water-05-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 3,
    title: "Severe Weather Alert",
    description: "Strong thunderstorms expected tonight. Possible flash flooding in low-lying areas. Stay indoors if possible.",
    time: "16:45",
    date: "2025-05-07",
    category: "safety",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Emergency Services",
    threadId: "vil-weather-05-2025",
    read: true,
    priority: "emergency"
  },
  {
    id: 4,
    title: "Traffic Restrictions",
    description: "Due to street festival, Gedimino Prospektas will be closed to traffic this weekend (May 10-11).",
    time: "09:00",
    date: "2025-05-06",
    category: "traffic",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Traffic Department",
    threadId: "vil-traffic-05-2025",
    read: false,
    priority: "important"
  },

  // More City Notifications with different priority levels
  
  // Vilnius - Various Priority Levels
  {
    id: 40,
    title: "Major Gas Leak - Evacuate Area",
    description: "URGENT: Gas leak detected at Konstitucijos pr. 25. Evacuate buildings within 200m radius immediately. Emergency services on scene.",
    time: "14:20",
    date: "2025-05-10",
    category: "safety",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Emergency Services",
    threadId: "vil-emergency-gas-2025",
    read: false,
    priority: "emergency"
  },
  {
    id: 41,
    title: "Missing Child Alert",
    description: "6-year-old boy missing from Vingis Park area since 13:00. Wearing blue jacket, red shoes. If seen, call 112 immediately.",
    time: "15:30",
    date: "2025-05-10",
    category: "safety",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Police Department",
    threadId: "vil-amber-alert-2025",
    read: false,
    priority: "emergency"
  },
  {
    id: 42,
    title: "Bridge Closure Notice",
    description: "Žirmūnų Bridge will be closed for repairs from May 15-20. Use alternative routes. Expect significant traffic delays.",
    time: "09:00",
    date: "2025-05-10",
    category: "traffic",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Transport Authority",
    threadId: "vil-bridge-closure-2025",
    read: false,
    priority: "important"
  },
  {
    id: 43,
    title: "Boil Water Advisory",
    description: "Due to pipe repairs, residents in Šnipiškės must boil tap water before drinking. Advisory in effect until further notice.",
    time: "11:45",
    date: "2025-05-10",
    category: "utility",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilniaus Vandenys",
    threadId: "vil-water-advisory-2025",
    read: false,
    priority: "important"
  },
  {
    id: 44,
    title: "Street Cleaning Schedule",
    description: "Annual street cleaning in Old Town starts Monday. Please move vehicles according to posted signs to avoid fines.",
    time: "16:00",
    date: "2025-05-09",
    category: "traffic",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius City Municipality",
    threadId: "vil-cleaning-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 45,
    title: "New Recycling Points",
    description: "10 new recycling points opened in Antakalnis district. Find the nearest one on our city app.",
    time: "10:30",
    date: "2025-05-08",
    category: "utility",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Waste Management",
    threadId: "vil-recycling-2025",
    read: true,
    priority: "standard"
  },

  // City Notifications - Kaunas
  {
    id: 5,
    title: "Public Transport Schedule Change",
    description: "Bus route #25 will operate on a modified schedule starting next week due to road construction.",
    time: "11:20",
    date: "2025-05-05",
    category: "transport",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Public Transport",
    threadId: "kau-transport-05-2025",
    read: true,
    priority: "standard"
  },
  {
    id: 6,
    title: "New Bike Lanes Opening",
    description: "The new bike lane network in central Kaunas will be officially opened this Friday with a community ride.",
    time: "14:30",
    date: "2025-05-06",
    category: "transport",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas City Municipality",
    threadId: "kau-bike-05-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 7,
    title: "River Flood Warning",
    description: "Nemunas river levels rising. Possible flooding in riverside areas in the next 48 hours. Prepare accordingly.",
    time: "08:15",
    date: "2025-05-09",
    category: "safety",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Emergency Services",
    threadId: "kau-flood-05-2025",
    read: false,
    priority: "emergency"
  },

  // Kaunas - Various Priority Levels
  {
    id: 46,
    title: "Tornado Warning",
    description: "TAKE SHELTER NOW! Tornado spotted moving towards Kaunas. Seek shelter in basements or interior rooms immediately.",
    time: "17:15",
    date: "2025-05-10",
    category: "safety",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Emergency Services",
    threadId: "kau-tornado-warning-2025",
    read: false,
    priority: "emergency"
  },
  {
    id: 47,
    title: "Power Outage Alert",
    description: "Widespread power outage affecting central Kaunas due to storm damage. Crews working to restore power. Est. restoration: 23:00.",
    time: "18:30",
    date: "2025-05-10",
    category: "utility",
    source: "city",
    cityName: "Kaunas",
    serviceName: "ESO Kaunas",
    threadId: "kau-power-outage-2025",
    read: false,
    priority: "important"
  },
  {
    id: 48,
    title: "Marathon Road Closures",
    description: "Kaunas Marathon this Sunday. Major streets in city center closed 08:00-14:00. Plan alternative routes.",
    time: "12:00",
    date: "2025-05-08",
    category: "traffic",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Police Department",
    threadId: "kau-marathon-2025",
    read: false,
    priority: "important"
  },
  {
    id: 49,
    title: "Free COVID Vaccinations",
    description: "Free COVID-19 booster shots available at all city clinics this week. No appointment necessary.",
    time: "09:30",
    date: "2025-05-07",
    category: "medical",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Public Health",
    threadId: "kau-vaccination-2025",
    read: true,
    priority: "standard"
  },

  // Klaipeda - Various Priority Levels
  {
    id: 50,
    title: "Tsunami Warning",
    description: "EXTREME DANGER: Tsunami warning for Baltic coast. Move to higher ground immediately. Do not return to shore.",
    time: "19:45",
    date: "2025-05-10",
    category: "safety",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Civil Protection",
    threadId: "kla-tsunami-2025",
    read: false,
    priority: "emergency"
  },
  {
    id: 51,
    title: "Port Strike Notice",
    description: "Port workers strike begins tomorrow. Expect delays in cargo operations and increased truck traffic in port area.",
    time: "14:00",
    date: "2025-05-09",
    category: "traffic",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Port Authority",
    threadId: "kla-port-strike-2025",
    read: false,
    priority: "important"
  },
  {
    id: 52,
    title: "Beach Water Quality",
    description: "High bacteria levels detected at Melnragė beach. Swimming not recommended until further testing.",
    time: "11:00",
    date: "2025-05-10",
    category: "safety",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Environmental Agency",
    threadId: "kla-beach-quality-2025",
    read: false,
    priority: "important"
  },
  {
    id: 53,
    title: "Jazz Festival Traffic",
    description: "Klaipeda Jazz Festival this weekend. Expect increased traffic and limited parking in Old Town area.",
    time: "15:30",
    date: "2025-05-08",
    category: "traffic",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Traffic Police",
    threadId: "kla-jazz-festival-2025",
    read: true,
    priority: "standard"
  },
  {
    id: 54,
    title: "New Ferry Schedule",
    description: "Summer ferry schedule to Smiltynė starts May 15. Increased frequency during peak hours.",
    time: "10:00",
    date: "2025-05-07",
    category: "transport",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Transport",
    threadId: "kla-ferry-schedule-2025",
    read: true,
    priority: "standard"
  },

  // Event notifications - Vilnius
  {
    id: 60,
    title: "Medieval Festival This Weekend",
    description: "Join us for the annual Medieval Festival at Gediminas Castle. Live performances, authentic food, knight tournaments. May 15-16, 10:00-20:00.",
    time: "09:00",
    date: "2025-05-12",
    category: "events",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Tourism Board",
    threadId: "vil-medieval-fest-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 61,
    title: "Independence Day Celebration",
    description: "City-wide celebration on May 25. Parade starts at 11:00 from Cathedral Square. Evening concert at Vingis Park amphitheater. Free entry.",
    time: "14:00",
    date: "2025-05-10",
    category: "events",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius City Events",
    threadId: "vil-independence-2025",
    read: false,
    priority: "important"
  },
  {
    id: 62,
    title: "Street Music Day",
    description: "Musicians of all ages perform throughout the city. Join the celebration of music on May 20. Maps of performance locations available on city website.",
    time: "11:30",
    date: "2025-05-08",
    category: "events",
    source: "city",
    cityName: "Vilnius",
    serviceName: "Vilnius Cultural Center",
    threadId: "vil-music-day-2025",
    read: false,
    priority: "standard"
  },

  // Event notifications - Kaunas
  {
    id: 63,
    title: "Hansa Days Festival",
    description: "Experience medieval Hanseatic League culture. Town Hall Square becomes a medieval marketplace. May 22-24, crafts, performances, traditional food.",
    time: "10:00",
    date: "2025-05-11",
    category: "events",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Tourism Board",
    threadId: "kau-hansa-days-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 64,
    title: "International Kite Festival",
    description: "Colorful kites fill the sky at Nemunas Island Park. Free workshops for children. May 18, 11:00-17:00. Bring your own kite or buy on-site.",
    time: "15:30",
    date: "2025-05-09",
    category: "events",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Parks Department",
    threadId: "kau-kite-fest-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 65,
    title: "Contemporary Art Biennial Opening",
    description: "Kaunas Biennial 2025 opens May 30. International artists showcase works across the city. Opening ceremony at 18:00, National M.K. Čiurlionis Museum.",
    time: "09:00",
    date: "2025-05-10",
    category: "events",
    source: "city",
    cityName: "Kaunas",
    serviceName: "Kaunas Art Gallery",
    threadId: "kau-biennial-2025",
    read: false,
    priority: "standard"
  },

  // Event notifications - Klaipeda
  {
    id: 66,
    title: "Sea Festival 2025",
    description: "Annual Sea Festival July 24-26. Tall ships parade, maritime exhibitions, concerts. Opening ceremony at Theatre Square 19:00.",
    time: "11:00",
    date: "2025-05-10",
    category: "events",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda City Events",
    threadId: "kla-sea-fest-2025",
    read: false,
    priority: "important"
  },
  {
    id: 67,
    title: "Smelt Festival Returns",
    description: "Traditional Smelt Festival on May 17. Fresh smelt tasting, fishing competitions, live music at Danė River embankment. 12:00-22:00.",
    time: "13:45",
    date: "2025-05-08",
    category: "events",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Tourism Center",
    threadId: "kla-smelt-fest-2025",
    read: false,
    priority: "standard"
  },
  {
    id: 68,
    title: "Castle Jazz Festival",
    description: "International jazz stars perform at Klaipeda Castle courtyard. June 5-7, evening concerts start at 20:00. Early bird tickets available.",
    time: "16:00",
    date: "2025-05-09",
    category: "events",
    source: "city",
    cityName: "Klaipeda",
    serviceName: "Klaipeda Castle Museum",
    threadId: "kla-castle-jazz-2025",
    read: false,
    priority: "standard"
  },

  // Business - Healthcare Service Group
  {
    id: 8,
    title: "Appointment Reminder",
    description: "Your appointment with Dr. Petraitis is tomorrow at 14:30. Please arrive 15 minutes early.",
    time: "10:00",
    date: "2025-05-08",
    category: "medical",
    source: "business",
    serviceGroup: "Healthcare",
    serviceName: "City Health Clinic",
    threadId: "health-appointment-12345",
    businessThreadId: "health-appointment-12345",
    read: true,
    priority: "important"
  },
  {
    id: 9,
    title: "Test Results Available",
    description: "Your recent lab test results are now available. Please log in to the patient portal to view them.",
    time: "15:20",
    date: "2025-05-09",
    category: "medical",
    source: "business",
    serviceGroup: "Healthcare",
    serviceName: "City Health Clinic",
    threadId: "health-results-67890",
    businessThreadId: "health-results-67890",
    read: false,
    priority: "important"
  },

  // Business - Shopping & Delivery Service Group
  {
    id: 10,
    title: "Order Confirmation",
    description: "Your order #34521 has been confirmed. Thank you for shopping with us!",
    time: "12:45",
    date: "2025-05-07",
    category: "shopping",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "TechMart Online",
    threadId: "order-34521",
    businessThreadId: "order-34521",
    read: true,
    priority: "standard"
  },
  {
    id: 11,
    title: "Payment Processed",
    description: "We've successfully processed payment for your order #34521. Your items are being prepared for shipping.",
    time: "13:10",
    date: "2025-05-07",
    category: "shopping",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "TechMart Online",
    threadId: "order-34521",
    businessThreadId: "order-34521",
    read: true,
    priority: "standard"
  },
  {
    id: 12,
    title: "Order Shipped",
    description: "Good news! Your order #34521 has been shipped. Expected delivery: May 11-12.",
    time: "09:30",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "TechMart Online",
    threadId: "order-34521",
    businessThreadId: "order-34521",
    read: false,
    priority: "standard"
  },
  {
    id: 15,
    title: "Order Picked Up by Courier",
    description: "Your package (Order #34521) has been picked up by our delivery partner DHL Express.",
    time: "11:45",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "DHL Express",
    threadId: "order-34521-delivery",
    businessThreadId: "order-34521",
    read: false,
    priority: "standard"
  },
  {
    id: 16,
    title: "Package In Transit",
    description: "Your package is in transit. Current location: Vilnius Distribution Center. Tracking: DHL-LT-34521",
    time: "16:20",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "DHL Express",
    threadId: "order-34521-delivery",
    businessThreadId: "order-34521",
    read: false,
    priority: "standard"
  },

  // More Business - Shopping & Delivery examples
  
  // Grocery Delivery
  {
    id: 19,
    title: "Order Placed",
    description: "Your grocery order #GR-8823 from MaxiMart has been received. Delivery scheduled for today between 18:00-20:00.",
    time: "14:30",
    date: "2025-05-09",
    category: "shopping",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "MaxiMart",
    threadId: "grocery-order-8823",
    businessThreadId: "grocery-order-8823",
    read: false,
    priority: "standard"
  },
  {
    id: 20,
    title: "Shopper Assigned",
    description: "Justina has been assigned as your personal shopper for order #GR-8823. She's now shopping for your items.",
    time: "16:15",
    date: "2025-05-09",
    category: "shopping",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "MaxiMart",
    threadId: "grocery-order-8823",
    businessThreadId: "grocery-order-8823",
    read: false,
    priority: "standard"
  },
  {
    id: 21,
    title: "Substitution Request",
    description: "The requested 'Organic Milk 1L' is out of stock. Would you like '2% Milk 1L' instead? Reply to approve/reject.",
    time: "16:45",
    date: "2025-05-09",
    category: "shopping",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "MaxiMart",
    threadId: "grocery-order-8823",
    businessThreadId: "grocery-order-8823",
    read: false,
    priority: "important"
  },
  {
    id: 22,
    title: "Out for Delivery",
    description: "Your MaxiMart order is on its way! Driver Jonas will arrive between 18:00-20:00. Track live on our app.",
    time: "17:50",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "MaxiMart",
    threadId: "grocery-order-8823",
    businessThreadId: "grocery-order-8823",
    read: false,
    priority: "standard"
  },

  // Food Delivery
  {
    id: 23,
    title: "Order Confirmed",
    description: "Your order from Burger Palace has been confirmed. Preparing your food now!",
    time: "12:15",
    date: "2025-05-10",
    category: "dining",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Wolt",
    threadId: "food-delivery-1122",
    businessThreadId: "food-delivery-1122",
    read: false,
    priority: "standard"
  },
  {
    id: 24,
    title: "Restaurant Update",
    description: "Burger Palace is preparing your order. Estimated ready time: 12:35.",
    time: "12:25",
    date: "2025-05-10",
    category: "dining",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Burger Palace",
    threadId: "food-delivery-1122",
    businessThreadId: "food-delivery-1122",
    read: false,
    priority: "standard"
  },
  {
    id: 25,
    title: "Courier Assigned",
    description: "Tomas is picking up your order. He's on a bicycle and will arrive in approximately 20 minutes.",
    time: "12:30",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Wolt",
    threadId: "food-delivery-1122",
    businessThreadId: "food-delivery-1122",
    read: false,
    priority: "standard"
  },
  {
    id: 26,
    title: "Order Picked Up",
    description: "Your courier has collected the order and is heading your way. ETA: 12:50.",
    time: "12:38",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Wolt",
    threadId: "food-delivery-1122",
    businessThreadId: "food-delivery-1122",
    read: false,
    priority: "standard"
  },
  {
    id: 27,
    title: "Courier Nearby",
    description: "Tomas is 2 minutes away! Please prepare to meet at the entrance.",
    time: "12:48",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Wolt",
    threadId: "food-delivery-1122",
    businessThreadId: "food-delivery-1122",
    read: false,
    priority: "important"
  },

  // International Package
  {
    id: 28,
    title: "International Shipment",
    description: "Your package from UK (tracking: INT-445522) has cleared Lithuanian customs.",
    time: "09:00",
    date: "2025-05-08",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "LP Express",
    threadId: "intl-package-445522",
    businessThreadId: "intl-package-445522",
    read: true,
    priority: "standard"
  },
  {
    id: 29,
    title: "Package in Transit",
    description: "Your international package is now in Vilnius sorting facility. Next stop: local delivery hub.",
    time: "14:30",
    date: "2025-05-08",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "LP Express",
    threadId: "intl-package-445522",
    businessThreadId: "intl-package-445522",
    read: true,
    priority: "standard"
  },
  {
    id: 30,
    title: "Out for Delivery Today",
    description: "Good news! Your package is on the delivery truck. Expected delivery: today between 10:00-18:00.",
    time: "08:15",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "LP Express",
    threadId: "intl-package-445522",
    businessThreadId: "intl-package-445522",
    read: false,
    priority: "standard"
  },
  {
    id: 31,
    title: "Delivery Attempted",
    description: "We attempted delivery but you weren't home. Package will be available at LP Express Pickup Point (Maxima Antakalnis) from tomorrow.",
    time: "15:45",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "LP Express",
    threadId: "intl-package-445522",
    businessThreadId: "intl-package-445522",
    read: false,
    priority: "important"
  },

  // Furniture Delivery
  {
    id: 32,
    title: "Delivery Scheduled",
    description: "Your IKEA order #IK-778899 is scheduled for delivery on May 15 between 09:00-13:00. Our team will call 30 minutes before arrival.",
    time: "11:00",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "IKEA",
    threadId: "furniture-delivery-778899",
    businessThreadId: "furniture-delivery-778899",
    read: false,
    priority: "standard"
  },
  {
    id: 33,
    title: "Assembly Service Reminder",
    description: "You've selected assembly service for your order. Our team will assemble: BILLY Bookcase, LACK Table. Additional time required: ~1 hour.",
    time: "11:05",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "IKEA",
    threadId: "furniture-delivery-778899",
    businessThreadId: "furniture-delivery-778899",
    read: false,
    priority: "standard"
  },

  // Pharmacy Delivery
  {
    id: 34,
    title: "Prescription Ready",
    description: "Your prescription #RX-445 is ready for delivery. Medications: Ibuprofen 400mg, Vitamin D3.",
    time: "10:30",
    date: "2025-05-10",
    category: "medical",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Eurovaistine",
    threadId: "pharmacy-delivery-445",
    businessThreadId: "pharmacy-delivery-445",
    read: false,
    priority: "important"
  },
  {
    id: 35,
    title: "Express Delivery",
    description: "Your medications are being delivered via express courier. Arrival in 60 minutes. Please have ID ready.",
    time: "11:00",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Eurovaistine",
    threadId: "pharmacy-delivery-445",
    businessThreadId: "pharmacy-delivery-445",
    read: false,
    priority: "important"
  },

  // Failed Delivery & Returns
  {
    id: 36,
    title: "Return Pickup Scheduled",
    description: "DPD will pick up your return package tomorrow between 10:00-14:00. Please have the package ready with return label attached.",
    time: "16:00",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "DPD Lithuania",
    threadId: "return-pickup-2233",
    businessThreadId: "return-pickup-2233",
    read: false,
    priority: "standard"
  },
  {
    id: 37,
    title: "Pickup Tomorrow",
    description: "Reminder: DPD courier will collect your return package tomorrow. Return authorization: RET-2233-LT.",
    time: "19:00",
    date: "2025-05-09",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "DPD Lithuania",
    threadId: "return-pickup-2233",
    businessThreadId: "return-pickup-2233",
    read: false,
    priority: "important"
  },

  // Same-day delivery
  {
    id: 38,
    title: "Same-Day Delivery",
    description: "Your urgent order from Electronics Hub will be delivered today by 20:00. Premium delivery charge: €9.99.",
    time: "15:30",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "Electronics Hub",
    threadId: "same-day-9988",
    businessThreadId: "same-day-9988",
    read: false,
    priority: "important"
  },
  {
    id: 39,
    title: "Driver En Route",
    description: "Your same-day delivery is 30 minutes away. Driver Mindaugas is delivering in a white van (LIT 123).",
    time: "18:30",
    date: "2025-05-10",
    category: "delivery",
    source: "business",
    serviceGroup: "Shopping & Delivery",
    serviceName: "QuickShip Express",
    threadId: "same-day-9988",
    businessThreadId: "same-day-9988",
    read: false,
    priority: "important"
  },

  // Business - Utilities Service Group
  {
    id: 13,
    title: "Electricity Bill Due",
    description: "Your electricity bill for April 2025 is due in 5 days. Total amount: €78.35",
    time: "08:00",
    date: "2025-05-05",
    category: "utility",
    source: "business",
    serviceGroup: "Utilities",
    serviceName: "Lietuvos Energija",
    threadId: "le-bill-04-2025",
    businessThreadId: "utility-bills-04-2025",
    read: true,
    priority: "important"
  },
  {
    id: 14,
    title: "New Energy Saving Program",
    description: "Join our new energy saving program and save up to 15% on your monthly bill. Click for details.",
    time: "11:45",
    date: "2025-05-08",
    category: "utility",
    source: "business",
    serviceGroup: "Utilities",
    serviceName: "Lietuvos Energija",
    threadId: "le-program-05-2025",
    businessThreadId: "le-program-05-2025",
    read: false,
    priority: "standard"
  },

  // Business - Dining & Entertainment Service Group
  {
    id: 17,
    title: "Table Reservation Confirmed",
    description: "Your table for 4 at La Boheme Restaurant is confirmed for May 12 at 19:00.",
    time: "14:30",
    date: "2025-05-08",
    category: "dining",
    source: "business",
    serviceGroup: "Dining & Entertainment",
    serviceName: "La Boheme Restaurant",
    threadId: "restaurant-booking-789",
    businessThreadId: "restaurant-booking-789",
    read: false,
    priority: "standard"
  },
  {
    id: 18,
    title: "Reminder: Table Reservation Tomorrow",
    description: "Don't forget your reservation at La Boheme Restaurant tomorrow at 19:00. Table for 4 people.",
    time: "10:00",
    date: "2025-05-11",
    category: "dining",
    source: "business",
    serviceGroup: "Dining & Entertainment",
    serviceName: "La Boheme Restaurant",
    threadId: "restaurant-booking-789",
    businessThreadId: "restaurant-booking-789",
    read: false,
    priority: "standard"
  }
];

// Filter notifications based on user subscriptions
// This function will be called with subscription context data
export const getFilteredNotifications = (isSubscribedToCity, isSubscribedToCityCategory) => {
  return notificationsData.filter(notification => {
    if (notification.source === 'city') {
      return isSubscribedToCity(notification.cityName) && 
             isSubscribedToCityCategory(notification.cityName, notification.category);
    } else {
      // Always show business notifications
      return true;
    }
  });
};

export const getServiceProviders = (isSubscribedToCity, isSubscribedToCityCategory) => {
  const servicesMap = {};
  const filteredNotifications = getFilteredNotifications(isSubscribedToCity, isSubscribedToCityCategory);
  
  // First, group businesses by service group
  filteredNotifications
    .filter(notification => notification.source === 'business')
    .forEach(notification => {
      const serviceGroup = notification.serviceGroup || 'Other Services';
      if (!servicesMap[serviceGroup]) {
        servicesMap[serviceGroup] = {
          name: serviceGroup,
          displayName: serviceGroup,
          source: 'business',
          unreadCount: notification.read ? 0 : 1,
          threadsCount: 1,
          threads: new Set([notification.businessThreadId || notification.threadId])
        };
      } else {
        if (!notification.read) {
          servicesMap[serviceGroup].unreadCount += 1;
        }
        const threadId = notification.businessThreadId || notification.threadId;
        if (!servicesMap[serviceGroup].threads.has(threadId)) {
          servicesMap[serviceGroup].threadsCount += 1;
          servicesMap[serviceGroup].threads.add(threadId);
        }
      }
    });

  // Then, group city notifications by city name
  filteredNotifications
    .filter(notification => notification.source === 'city')
    .forEach(notification => {
      const key = `[City] ${notification.cityName}`;
      if (!servicesMap[key]) {
        servicesMap[key] = {
          name: key,
          displayName: notification.cityName,
          source: notification.source,
          cityName: notification.cityName,
          unreadCount: notification.read ? 0 : 1,
          threadsCount: 0, // Cities don't have threads anymore
          threads: new Set()
        };
      } else {
        if (!notification.read) {
          servicesMap[key].unreadCount += 1;
        }
      }
    });

  return Object.values(servicesMap).map(service => ({
    name: service.name,
    displayName: service.displayName,
    source: service.source,
    cityName: service.cityName,
    unreadCount: service.unreadCount,
    threadsCount: service.threadsCount
  }));
};

export const getThreadsByService = (serviceName, isSubscribedToCity, isSubscribedToCityCategory) => {
  const threads = {};
  const filteredNotifications = getFilteredNotifications(isSubscribedToCity, isSubscribedToCityCategory);
  
  // Check if this is a city service
  const isCityService = serviceName.startsWith('[City]');
  const cityName = isCityService ? serviceName.replace('[City] ', '') : null;

  filteredNotifications
    .filter(notification => {
      if (isCityService) {
        return notification.source === 'city' && notification.cityName === cityName;
      } else {
        // For business services, match by serviceGroup
        return notification.source === 'business' && notification.serviceGroup === serviceName;
      }
    })
    .forEach(notification => {
      const threadKey = notification.businessThreadId || notification.threadId;
      
      if (!threads[threadKey]) {
        // Get all notifications in this business thread
        const threadNotifications = filteredNotifications
          .filter(n => {
            const nBusinessThreadId = n.businessThreadId || n.threadId;
            return nBusinessThreadId === threadKey;
          })
          .sort((a, b) => new Date(a.date + 'T' + a.time) - new Date(b.date + 'T' + b.time));
        
        const firstNotification = threadNotifications[0];
        const lastNotification = threadNotifications[threadNotifications.length - 1];
        
        // Get all services involved in this thread
        const services = new Set(threadNotifications.map(n => n.serviceName));
        const servicesList = Array.from(services);
        
        // Get appropriate title for business threads
        const title = notification.source === 'business' 
          ? getBusinessThreadTitle(threadNotifications)
          : firstNotification.title;
        
        threads[threadKey] = {
          id: threadKey,
          title: title,
          serviceName: servicesList.length > 1 ? servicesList.join(' + ') : servicesList[0],
          services: servicesList,
          category: notification.category,
          latestDate: lastNotification.date,
          latestTime: lastNotification.time,
          count: threadNotifications.length,
          unreadCount: threadNotifications.filter(n => !n.read).length,
          priority: threadNotifications.some(n => n.priority === 'emergency') 
            ? 'emergency' 
            : threadNotifications.some(n => n.priority === 'important') 
              ? 'important' 
              : 'standard'
        };
      }
    });
  
  return Object.values(threads).sort((a, b) => {
    // Sort by date and time (newest first)
    const dateTimeA = new Date(a.latestDate + 'T' + a.latestTime);
    const dateTimeB = new Date(b.latestDate + 'T' + b.latestTime);
    return dateTimeB - dateTimeA;
  });
};

export const getNotificationsByThread = (threadId, isSubscribedToCity, isSubscribedToCityCategory) => {
  const filteredNotifications = getFilteredNotifications(isSubscribedToCity, isSubscribedToCityCategory);
  return filteredNotifications
    .filter(notification => {
      // For business notifications, check businessThreadId or fall back to threadId
      const notificationThreadId = notification.businessThreadId || notification.threadId;
      return notificationThreadId === threadId;
    })
    .sort((a, b) => {
      // Sort by date and time (newest last)
      const dateTimeA = new Date(a.date + 'T' + a.time);
      const dateTimeB = new Date(b.date + 'T' + b.time);
      return dateTimeA - dateTimeB;
    });
};

export const getCategoryColor = (category) => {
  switch (category) {
    case 'safety':
      return 'bg-red-500';
    case 'traffic':
    case 'transport':
      return 'bg-amber-500';
    case 'utility':
      return 'bg-blue-500';
    case 'medical':
      return 'bg-green-500';
    case 'shopping':
      return 'bg-purple-500';
    case 'delivery':
      return 'bg-orange-500';
    case 'dining':
      return 'bg-pink-500';
    case 'events':
      return 'bg-indigo-500';
    default:
      return 'bg-gray-500';
  }
};

export const getPriorityClass = (priority) => {
  switch (priority) {
    case 'emergency':
      return 'priority-emergency';
    case 'important':
      return 'priority-important';
    default:
      return '';
  }
};

export const updateNotificationReadStatus = (notificationId, status) => {
  const notification = notificationsData.find(n => n.id === notificationId);
  if (notification) {
    notification.read = status;
  }
};

export const markAllAsRead = () => {
  notificationsData.forEach(notification => {
    notification.read = true;
  });
};

export const markThreadAsRead = (threadId) => {
  notificationsData
    .filter(notification => notification.threadId === threadId)
    .forEach(notification => {
      notification.read = true;
    });
};

export const markServiceAsRead = (serviceName) => {
  // Check if this is a city service
  const isCityService = serviceName.startsWith('[City]');
  const cityName = isCityService ? serviceName.replace('[City] ', '') : null;

  notificationsData
    .filter(notification => {
      if (isCityService) {
        return notification.source === 'city' && notification.cityName === cityName;
      } else {
        return notification.source === 'business' && notification.serviceGroup === serviceName;
      }
    })
    .forEach(notification => {
      notification.read = true;
    });
};

export const getTotalUnreadCount = (isSubscribedToCity, isSubscribedToCityCategory) => {
  const filteredNotifications = getFilteredNotifications(isSubscribedToCity, isSubscribedToCityCategory);
  return filteredNotifications.filter(notification => !notification.read).length;
};

export const getCityUnreadCount = (isSubscribedToCity, isSubscribedToCityCategory) => {
  const filteredNotifications = getFilteredNotifications(isSubscribedToCity, isSubscribedToCityCategory);
  return filteredNotifications.filter(notification => !notification.read && notification.source === 'city').length;
};

export const getBusinessUnreadCount = (isSubscribedToCity, isSubscribedToCityCategory) => {
  const filteredNotifications = getFilteredNotifications(isSubscribedToCity, isSubscribedToCityCategory);
  return filteredNotifications.filter(notification => !notification.read && notification.source === 'business').length;
};

export const getBusinessThreadTitle = (notifications) => {
  // For orders, find order number
  const orderNotification = notifications.find(n => 
    n.description.toLowerCase().includes('order #') || 
    n.title.toLowerCase().includes('order'));
  
  if (orderNotification) {
    const orderMatch = orderNotification.description.match(/#(\d+)/) || 
                      orderNotification.title.match(/#(\d+)/);
    if (orderMatch) {
      return `Order #${orderMatch[1]}`;
    }
  }
  
  // For medical appointments
  if (notifications.some(n => n.category === 'medical' && n.title.includes('Appointment'))) {
    return 'Medical Appointment';
  }
  
  // For test results
  if (notifications.some(n => n.category === 'medical' && n.title.includes('Test Results'))) {
    return 'Test Results';
  }
  
  // For restaurant bookings
  if (notifications.some(n => n.category === 'dining')) {
    return 'Restaurant Booking';
  }
  
  // Default to first notification title
  return notifications[0].title;
};
